import { CurrencyCodeType } from '@/types/currency';
import { FiatAccountType } from '@/types/fiatAccountType';
import { Page } from '@/types/page';
import { StatusType, Transaction, TransactionType } from '@/types/transaction';

const mockTransactions: Transaction[] = [
  {
    id: 'TXN-001',
    date: '2025-01-14T10:30:00Z',
    status: StatusType.SUCCEEDED,
    type: TransactionType.TRANSFER,
    paymentType: FiatAccountType.wire,
    fromAccountAlias: 'Main USD Account',
    fromAccount: {
      id: 'acc-001',
      name: 'Main USD Account',
      beneficiaryId: 'ben-001',
      belongsToBeneficiary: true,
      fiatAccountType: FiatAccountType.wire,
      accountDetails: {
        wireDetails: {
          personInfo: {
            name: 'John Doe',
            street1: '123 Main St',
            postalCode: '10001',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000021',
            accountNumber: '1234567890',
            accountType: 'checking' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            bic: 'CHASUS33XXX',
            name: 'Chase Bank',
            street1: '270 Park Ave',
            street2: '',
            postalCode: '10017',
            city: 'New York',
            state: 'NY',
            country: 'US',
          },
        },
      },
    },
    fromAmount: { currencyCode: CurrencyCodeType.USD, value: 1000.0 },
    toAccountAlias: 'Business Account',
    toAccount: {
      id: 'acc-002',
      name: 'Business Account',
      beneficiaryId: 'ben-002',
      belongsToBeneficiary: false,
      fiatAccountType: FiatAccountType.ach,
      accountDetails: {
        achDetails: {
          personInfo: {
            name: 'ABC Corp',
            street1: '456 Business Ave',
            postalCode: '10002',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000022',
            accountNumber: '0987654321',
            accountType: 'checking' as any,
            type: 'company' as any,
          },
          bankInfo: {
            routingNumber: '021000022',
            name: 'Bank of America',
            street1: '100 North Tryon St',
            street2: '',
            postalCode: '28255',
            city: 'Charlotte',
            state: 'NC',
            country: 'US',
          },
        },
      },
    },
    toAmount: { currencyCode: CurrencyCodeType.USD, value: 1000.0 },
    localInfo: {
      speiInClabe: '002180701234567890',
      speiInBankName: 'Banco Santander',
      speiInBeneficiaryName: 'John Doe',
    },
    transactionDetails: {
      feeDetails: {
        taxes: { currencyCode: CurrencyCodeType.USD, value: 1.5 },
        totalFees: { currencyCode: CurrencyCodeType.USD, value: 5.0 },
        integratorFee: { currencyCode: CurrencyCodeType.USD, value: 3.5 },
        fixedFees: [],
        oldFees: [],
        percentageFees: [],
        spreadFees: [],
        vet: '0.0000',
      },
      transferPurpose: 'Business payment',
      paymentReference: 'INV-2025-001',
      memo: 'Payment for services rendered',
      expectedSettlementTimeDetails: null,
    },
    initiatedBy: 'John Doe',
    completed: true,
  },
  {
    id: 'TXN-002',
    date: '2025-01-13T15:45:00Z',
    status: StatusType.PENDING,
    type: TransactionType.DEPOSIT,
    paymentType: FiatAccountType.ach,
    fromAccountAlias: null,
    fromAccount: null,
    fromAmount: { currencyCode: CurrencyCodeType.USD, value: 2500.0 },
    toAccountAlias: 'Savings Account',
    toAccount: {
      id: 'acc-003',
      name: 'Savings Account',
      beneficiaryId: 'ben-001',
      belongsToBeneficiary: true,
      fiatAccountType: FiatAccountType.ach,
      accountDetails: {
        achDetails: {
          personInfo: {
            name: 'John Doe',
            street1: '123 Main St',
            postalCode: '10001',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000021',
            accountNumber: '1234567891',
            accountType: 'savings' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            routingNumber: '021000021',
            name: 'Chase Bank',
            street1: '270 Park Ave',
            street2: '',
            postalCode: '10017',
            city: 'New York',
            state: 'NY',
            country: 'US',
          },
        },
      },
    },
    toAmount: { currencyCode: CurrencyCodeType.USD, value: 2500.0 },
    localInfo: {
      pixCopyAndPaste: 'pix-copy-paste-string-here',
      pixExpiresAt: '',
    },
    transactionDetails: {
      feeDetails: {
        taxes: null,
        totalFees: { currencyCode: CurrencyCodeType.USD, value: 0.0 },
        integratorFee: { currencyCode: CurrencyCodeType.USD, value: 0.0 },
        fixedFees: [],
        oldFees: [],
        percentageFees: [],
        spreadFees: [],
        vet: '0.0000',
      },
      transferPurpose: 'Account funding',
      paymentReference: 'DEP-2025-002',
      memo: 'Initial deposit',
      expectedSettlementTimeDetails: null,
    },
    initiatedBy: 'John Doe',
    completed: false,
  },
  {
    id: 'TXN-003',
    date: '2025-01-12T09:20:00Z',
    status: StatusType.FAILED,
    type: TransactionType.WITHDRAWAL,
    paymentType: FiatAccountType.wire,
    fromAccountAlias: 'Investment Account',
    fromAccount: {
      id: 'acc-004',
      name: 'Investment Account',
      beneficiaryId: 'ben-001',
      belongsToBeneficiary: true,
      fiatAccountType: FiatAccountType.wire,
      accountDetails: {
        wireDetails: {
          personInfo: {
            name: 'John Doe',
            street1: '123 Main St',
            postalCode: '10001',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000021',
            accountNumber: '1234567892',
            accountType: 'checking' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            bic: 'CHASUS33XXX',
            name: 'Chase Bank',
            street1: '270 Park Ave',
            street2: '',
            postalCode: '10017',
            city: 'New York',
            state: 'NY',
            country: 'US',
          },
        },
      },
    },
    fromAmount: { currencyCode: CurrencyCodeType.USD, value: 750.0 },
    toAccountAlias: 'External Bank',
    toAccount: null,
    toAmount: { currencyCode: CurrencyCodeType.USD, value: 750.0 },
    localInfo: {
      speiOutClabe: '002180701234567891',
      speiOutSearchableId: 'search-003',
    },
    transactionDetails: {
      feeDetails: {
        taxes: { currencyCode: CurrencyCodeType.USD, value: 2.25 },
        totalFees: { currencyCode: CurrencyCodeType.USD, value: 15.0 },
        integratorFee: { currencyCode: CurrencyCodeType.USD, value: 12.75 },
        fixedFees: [],
        oldFees: [],
        percentageFees: [],
        spreadFees: [],
        vet: '0.0000',
      },
      transferPurpose: 'Investment withdrawal',
      paymentReference: 'WTH-2025-003',
      memo: 'Emergency funds',
      expectedSettlementTimeDetails: null,
    },
    initiatedBy: 'John Doe',
    completed: true,
  },
  {
    id: 'TXN-004',
    date: '2025-01-11T14:10:00Z',
    status: StatusType.SUCCEEDED,
    type: TransactionType.EXCHANGE,
    paymentType: FiatAccountType.wire,
    fromAccountAlias: 'EUR Account',
    fromAccount: {
      id: 'acc-005',
      name: 'EUR Account',
      beneficiaryId: 'ben-001',
      belongsToBeneficiary: true,
      fiatAccountType: FiatAccountType.wire,
      accountDetails: {
        wireDetails: {
          personInfo: {
            name: 'John Doe',
            street1: '123 Main St',
            postalCode: '10001',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000021',
            accountNumber: '1234567893',
            accountType: 'checking' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            bic: 'CHASUS33XXX',
            name: 'Chase Bank',
            street1: '270 Park Ave',
            street2: '',
            postalCode: '10017',
            city: 'New York',
            state: 'NY',
            country: 'US',
          },
        },
      },
    },
    fromAmount: { currencyCode: 'EUR' as any, value: 850.0 },
    toAccountAlias: 'USD Account',
    toAccount: {
      id: 'acc-001',
      name: 'Main USD Account',
      beneficiaryId: 'ben-001',
      belongsToBeneficiary: true,
      fiatAccountType: FiatAccountType.wire,
      accountDetails: {
        wireDetails: {
          personInfo: {
            name: 'John Doe',
            street1: '123 Main St',
            postalCode: '10001',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000021',
            accountNumber: '1234567890',
            accountType: 'checking' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            bic: 'CHASUS33XXX',
            name: 'Chase Bank',
            street1: '270 Park Ave',
            street2: '',
            postalCode: '10017',
            city: 'New York',
            state: 'NY',
            country: 'US',
          },
        },
      },
    },
    toAmount: { currencyCode: CurrencyCodeType.USD, value: 918.75 },
    localInfo: {
      targetPixKey: 'john.doe@email.com',
      pixOutSearchableId: 'search-004',
    },
    transactionDetails: {
      conversionDetails: {
        effectiveTransactionValue: 918.75,
        marketExchangeRate: 1.08,
        clientRate: 1.081,
        calizaRate: 1.081,
        amountToBeConverted: { currencyCode: 'EUR' as any, value: 850.0 },
      },
      feeDetails: {
        taxes: { currencyCode: CurrencyCodeType.USD, value: 2.75 },
        totalFees: { currencyCode: CurrencyCodeType.USD, value: 8.25 },
        integratorFee: { currencyCode: CurrencyCodeType.USD, value: 5.5 },
        fixedFees: [],
        oldFees: [],
        percentageFees: [],
        spreadFees: [],
        vet: '0.0000',
      },
      transferPurpose: 'Currency exchange',
      paymentReference: 'EXC-2025-004',
      memo: 'EUR to USD conversion',
      expectedSettlementTimeDetails: null,
    },
    initiatedBy: 'John Doe',
    completed: true,
  },
  {
    id: 'TXN-005',
    date: '2025-01-10T11:30:00Z',
    status: StatusType.WAITING_WEBHOOK,
    type: TransactionType.TRANSFER,
    paymentType: FiatAccountType.ach,
    fromAccountAlias: 'Checking Account',
    fromAccount: {
      id: 'acc-006',
      name: 'Checking Account',
      beneficiaryId: 'ben-001',
      belongsToBeneficiary: true,
      fiatAccountType: FiatAccountType.ach,
      accountDetails: {
        achDetails: {
          personInfo: {
            name: 'John Doe',
            street1: '123 Main St',
            postalCode: '10001',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000021',
            accountNumber: '1234567894',
            accountType: 'checking' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            routingNumber: '021000021',
            name: 'Chase Bank',
            street1: '270 Park Ave',
            street2: '',
            postalCode: '10017',
            city: 'New York',
            state: 'NY',
            country: 'US',
          },
        },
      },
    },
    fromAmount: { currencyCode: CurrencyCodeType.USD, value: 450.0 },
    toAccountAlias: 'Family Account',
    toAccount: {
      id: 'acc-007',
      name: 'Family Account',
      beneficiaryId: 'ben-003',
      belongsToBeneficiary: false,
      fiatAccountType: FiatAccountType.ach,
      accountDetails: {
        achDetails: {
          personInfo: {
            name: 'Jane Doe',
            street1: '789 Oak St',
            postalCode: '10003',
            city: 'New York',
            state: 'NY',
            country: 'US',
            routingKey: '021000023',
            accountNumber: '5432109876',
            accountType: 'savings' as any,
            type: 'individual' as any,
          },
          bankInfo: {
            routingNumber: '021000023',
            name: 'Wells Fargo',
            street1: '420 Montgomery St',
            street2: '',
            postalCode: '94104',
            city: 'San Francisco',
            state: 'CA',
            country: 'US',
          },
        },
      },
    },
    toAmount: { currencyCode: CurrencyCodeType.USD, value: 450.0 },
    localInfo: {
      speiInClabe: '002180701234567892',
      speiInBankName: 'Banco BBVA',
      speiInBeneficiaryName: 'Jane Doe',
    },
    transactionDetails: {
      feeDetails: {
        taxes: { currencyCode: CurrencyCodeType.USD, value: 1.35 },
        totalFees: { currencyCode: CurrencyCodeType.USD, value: 3.0 },
        integratorFee: { currencyCode: CurrencyCodeType.USD, value: 1.65 },
        fixedFees: [],
        oldFees: [],
        percentageFees: [],
        spreadFees: [],
        vet: '0.0000',
      },
      transferPurpose: 'Family support',
      paymentReference: 'FAM-2025-005',
      memo: 'Monthly allowance',
      expectedSettlementTimeDetails: null,
    },
    initiatedBy: 'John Doe',
    completed: false,
  },
];

// Generate additional mock transactions for pagination testing
const generateMockTransaction = (index: number): Transaction => ({
  id: `TXN-${String(index).padStart(3, '0')}`,
  date: new Date(Date.now() - index * 24 * 60 * 60 * 1000).toISOString(),
  status: [StatusType.SUCCEEDED, StatusType.PENDING, StatusType.FAILED][index % 3],
  type: [
    TransactionType.TRANSFER,
    TransactionType.DEPOSIT,
    TransactionType.WITHDRAWAL,
    TransactionType.EXCHANGE,
  ][index % 4],
  paymentType: [FiatAccountType.wire, FiatAccountType.ach][index % 2],
  fromAccountAlias: `Account ${index}`,
  fromAccount: {
    id: `acc-${index}`,
    name: `Account ${index}`,
    beneficiaryId: 'ben-001',
    belongsToBeneficiary: true,
    fiatAccountType: FiatAccountType.ach,
    accountDetails: {
      achDetails: {
        personInfo: {
          name: 'Mock User',
          street1: `${index} Mock St`,
          postalCode: '10001',
          city: 'Mock City',
          state: 'NY',
          country: 'US',
          routingKey: '021000021',
          accountNumber: `123456789${index}`,
          accountType: 'checking' as any,
          type: 'individual' as any,
        },
        bankInfo: {
          routingNumber: '021000021',
          name: 'Mock Bank',
          street1: '100 Mock Ave',
          street2: '',
          postalCode: '10001',
          city: 'Mock City',
          state: 'NY',
          country: 'US',
        },
      },
    },
  },
  fromAmount: { currencyCode: CurrencyCodeType.USD, value: index * 100 },
  toAccountAlias: `Recipient ${index}`,
  toAccount: null,
  toAmount: { currencyCode: CurrencyCodeType.USD, value: index * 100 },
  localInfo: {
    speiInClabe: `00218070123456789${index % 10}`,
    speiInBankName: 'Mock Bank',
    speiInBeneficiaryName: 'Mock Recipient',
  },
  transactionDetails: {
    feeDetails: {
      taxes: null,
      totalFees: { currencyCode: CurrencyCodeType.USD, value: 5.0 },
      integratorFee: { currencyCode: CurrencyCodeType.USD, value: 3.0 },
      fixedFees: [],
      oldFees: [],
      percentageFees: [],
      spreadFees: [],
      vet: '0.0000',
    },
    transferPurpose: 'Mock transaction',
    paymentReference: `MOCK-${index}`,
    memo: `Mock transaction #${index}`,
    expectedSettlementTimeDetails: null,
  },
  initiatedBy: 'Mock User',
  completed: [true, false, true][index % 3],
});

// Add more transactions for testing pagination
for (let i = 6; i <= 50; i++) {
  mockTransactions.push(generateMockTransaction(i));
}

export const createMockTransactionsPage = (
  page: number = 0,
  size: number = 20,
): Page<Transaction> => {
  const startIndex = page * size;
  const endIndex = startIndex + size;
  const content = mockTransactions.slice(startIndex, endIndex);

  return {
    content,
    pageable: {
      pageNumber: page,
      pageSize: size,
    },
    totalElements: mockTransactions.length,
    totalPages: Math.ceil(mockTransactions.length / size),
    last: endIndex >= mockTransactions.length,
    first: page === 0,
    numberOfElements: content.length,
    size,
    sort: {
      sorted: false,
      empty: true,
      unsorted: true,
    },
    empty: content.length === 0,
  };
};

export { mockTransactions };
